import gql from 'graphql-tag';
import graphqlClient from '@shared/graphql/client';
import { get } from 'lodash'

export class FinantialSettingsPayoutScheduleService {
  static async settings({ subpropertyId }) {
    const response = await graphqlClient.query({
      query: gql`
        query SUBPROPERTY_STRIPE_DATA(
          $subpropertyId: String!
        ) {
          stripeSubpropertyDataFind(
            subpropertyId: $subpropertyId
          ) {
            
            connectedAccount {
              id
              stripeConnectedAccountId
              settings {
                paymentsStatementDescriptor
                payoutsScheduleDelayDays
                payoutsScheduleInterval
                payoutsScheduleMonthlyAnchor
                payoutsScheduleWeeklyAnchor
                payoutsStatementDescriptor
              }
            }
          }
        }
      `,

      variables: {
        subpropertyId
      },
    });

    return get(response.data.stripeSubpropertyDataFind, 'connectedAccount', null);
  }

  static async update(propertyId, connectedAccountId, stripeConnectedAccountId, data) {
    const response = await graphqlClient.mutate({
        mutation: gql `
          mutation CONNECTED_ACCOUNT_SETTINGS_UPDATE(
            $propertyId: String!,
            $connectedAccountId: String!,
            $stripeConnectedAccountId: String!,
            $data: StripeConnectedAccountSettingsInput
          ) {
            stripeConnectedAccountSettingsUpdate(propertyId: $propertyId, connectedAccountId: $connectedAccountId, stripeConnectedAccountId: $stripeConnectedAccountId, data: $data) {
              paymentsStatementDescriptor
              payoutsScheduleDelayDays
              payoutsScheduleInterval
              payoutsScheduleMonthlyAnchor
              payoutsScheduleWeeklyAnchor
              payoutsStatementDescriptor
            }
          }
        `,

        variables: {
          propertyId,
          connectedAccountId,
          stripeConnectedAccountId,
          data
        },
    });

    return response.data.stripeConnectedAccountSettingsUpdate;
  }
}
